import AreaPage from "./AreaPage";
import { SWANSEA_DATA } from "./areaData";

const SwanseaPage = () => <AreaPage {...SWANSEA_DATA} />;

export default SwanseaPage;
